import script from "./MobileReportHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileReportHistory.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/mobile/ticket.css?vue&type=style&index=0&id=65d1536f&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65d1536f"]])

export default __exports__